import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchTournament } from '../actions';
import AdminNavigationBar from './AdminNavigationBar';
import { locationFilters, rankFilters } from '../utils/tournaments';
import { receiveTournament } from '../actions';
import { fallbackOnUndefined } from '../utils/helpers';

import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';

class TournamentEditor extends Component {

  constructor() {
    super();
    this.state = {};
    this.onStartDateTimeChange = this.onStartDateTimeChange.bind(this);
    this.onRegistrationStartDateTimeChange = this.onRegistrationStartDateTimeChange.bind(this);
    this.onRegistrationEndDateTimeChange = this.onRegistrationEndDateTimeChange.bind(this);
    this.updateTournament = this.updateTournament.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    if (this.tournament() === undefined) {
      dispatch(fetchTournament(this.tournamentId()));
    }
  }

  tournamentId() {
    return parseInt(this.props.match.params.id, 10);
  }

  tournament() {
    return this.props.tournaments.find(tournament => tournament.id === this.tournamentId());
  }

  render() {
    const tournament = this.tournament() || {};
    const tournamentRegistrationInfo = tournament.registrationInfo || {};

    return (
      <div>
        <AdminNavigationBar />
        <div className="container">
          <h1>Edycja turnieju</h1>
          { this.state.updated ? <div className="inline-block alert alert-info">Zapisano zmiany.</div> : ''}
          { this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : '' }
          <form>
            <div className="form-row ml-2">
              <div className="form-group col-md-3">
                <label>Nazwa:</label>
                <input
                  type="text"
                  className={"form-control " + this.validationClass('name')}
                  value={fallbackOnUndefined(this.state.name, tournament.name)}
                  onChange={this.onNameChange()}></input>
              </div>
              <div className="form-group col-md-3">
                <label>Ranga:</label>
                <select
                  id="inputState"
                  value={fallbackOnUndefined(this.state.rank, tournament.rank)}
                  onChange={this.onRankChange()}
                  className={"form-control " + this.validationClass('rank')}>
                  {
                    Object.keys(rankFilters).map(value => {
                      return (<option value={value}>{rankFilters[value]}</option>);
                    })
                  }
                </select>
              </div>
            </div>
            <div className="form-row ml-2">
              <div className="form-group col-md-3">
                <label>Miejscowość:</label>
                <input
                  type="text"
                  className={"form-control " + this.validationClass('shortDescription')}
                  value={fallbackOnUndefined(this.state.shortDescription, tournament.shortDescription)}
                  onChange={this.onShortDescriptionChange()}></input>
              </div>
              <div className="form-group col-md-3">
                <label>Województwo:</label>
                <select
                  id="inputState"
                  value={fallbackOnUndefined(this.state.locationCode, tournament.locationCode)}
                  onChange={this.onLocationCodeChange()}
                  className={"form-control " + this.validationClass('locationCode')}>
                  {
                    Object.keys(locationFilters).map(value => {
                      return (<option value={value}>{locationFilters[value]}</option>);
                    })
                  }
                </select>
              </div>
            </div>
            <div className="form-group col-md-6">
              <label>Opis:</label>
              <div>
                <textarea
                  className={"form-control " + this.validationClass('detailedDescription')}
                  value={fallbackOnUndefined(this.state.detailedDescription, tournament.detailedDescription)}
                  onChange={this.onDetailedDescriptionChange()}></textarea>
              </div>
            </div>
            <div className="form-group col-md-3">
              <label>Czas rozpoczęcia turnieju:</label>
              <Flatpickr
                className={"form-control " + this.validationClass('startTime')}
                data-enable-time
                data-position="above"
                data-time_24hr
                data-allow-input="true"
                data-date-format="d.m.Y H:i"
                value={fallbackOnUndefined(this.state.startDate, tournament.startTime)}
                onChange={this.onStartDateTimeChange} />
            </div>
            <div className="form-row ml-2">
              <div className="form-group col-md-2">
                <label>Rejestracja od:</label>
                <Flatpickr
                  className={"form-control " + this.validationClass('registrationInfo.startTime')}
                  data-enable-time
                  data-position="above"
                  data-time_24hr
                  data-allow-input="true"
                  data-date-format="d.m.Y H:i"
                  value={fallbackOnUndefined(this.state.registrationStartDateTime, tournamentRegistrationInfo.startTime)}
                  onChange={this.onRegistrationStartDateTimeChange} />
              </div>
              <div className="form-group col-md-2">
                <label>do:</label>
                <Flatpickr
                  className={"form-control " + this.validationClass('registrationInfo.endTime')}
                  data-enable-time
                  data-position="above"
                  data-time_24hr
                  data-allow-input="true"
                  data-date-format="d.m.Y H:i"
                  value={fallbackOnUndefined(this.state.registrationEndDateTime, tournamentRegistrationInfo.endTime)}
                  onChange={this.onRegistrationEndDateTimeChange} />
              </div>
            </div>
            <div className="form-group col-md-3">
              <label>Limit zgłoszeń:</label>
              <input
                type="number"
                className={"form-control " + this.validationClass('registrationInfo.participantLimit')}
                min="1"
                step="1"
                value={fallbackOnUndefined(this.state.participantLimit, tournamentRegistrationInfo.participantLimit)}
                onChange={this.onParticipantLimitChange()}></input>
            </div>
            <div className="form-group">
              <button className="btn btn-primary" onClick={this.updateTournament}>Zmień</button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  validationClass(fieldName) {
    if (this.state.invalidFields && this.state.invalidFields.includes(fieldName)) {
      return 'is-invalid';
    } else {
      return '';
    }
  }

  updateTournament() {
    const { dispatch } = this.props;
    const tournament = this.tournament();

    fetch(
      `/api/tournaments/${this.tournamentId()}`,
      {
        method: 'PATCH',
        headers: {
          'content-type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          rank: this.state.rank,
          name: this.state.name,
          shortDescription: this.state.shortDescription,
          detailedDescription: this.state.detailedDescription,
          locationCode: this.state.locationCode,
          startTime: this.state.startDateTime,
          registrationInfo: {
            participantLimit: this.state.participantLimit,
            startTime: this.state.registrationStartDateTime ? new Date(this.state.registrationStartDateTime).toISOString() : undefined,
            endTime: this.state.registrationEndDateTime ? new Date(this.state.registrationEndDateTime).toISOString() : undefined
          }
        })
      }).then(response => {
        if (response.status === 200) {
          dispatch(receiveTournament(response.json()));
          this.setState({
            updated: true,
            error: undefined
          });
        } else {
          response.json().then(data => this.setState({
            error: 'Podano nieprawidłowe dane!',
            invalidFields: data.errors
          }));
        }
      });
  }

  mergeDateWithTime(date, time) {
    if (date && time) {
      return new Date(date + ' ' + time).toISOString(); 
    } else {
      return null;
    }
  }

  onNameChange() {
    return (evt) => {
      this.setState({ name: evt.target.value, updated: undefined });
    };
  }

  onRankChange() {
    return (evt) => {
      this.setState({ rank: evt.target.value, updated: undefined });
    };
  }

  onLocationCodeChange() {
    return (evt) => {
      this.setState({ locationCode: evt.target.value, updated: undefined });
    };
  }

  onShortDescriptionChange() {
    return (evt) => {
      this.setState({ shortDescription: evt.target.value, updated: undefined });
    };
  }

  onDetailedDescriptionChange() {
    return (evt) => {
      this.setState({ detailedDescription: evt.target.value, updated: undefined });
    };
  }

  onParticipantLimitChange() {
    return (evt) => {
      this.setState({ participantLimit: parseInt(evt.target.value, 10), updated: undefined });
    };
  }

  onStartDateTimeChange(value) {
    this.setState({ startDateTime: value[0], updated: undefined });
  }

  onRegistrationStartDateTimeChange(value) {
    this.setState({ registrationStartDateTime: value[0], updated: undefined });
  }

  onRegistrationEndDateTimeChange(value) {
    this.setState({ registrationEndDateTime: value[0], updated: undefined });
  }
}

function mapStateToProps(state) {
  return { tournaments: state.tournaments };
}

export default connect(mapStateToProps)(TournamentEditor);



// WEBPACK FOOTER //
// ./components/TournamentEditor.js